"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Portfolio() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const specimens = [{
    glyph: "Br",
    family: "Branding",
    category: "Strategy · Design",
    meta: "Full visual systems ·",
    font: "var(--font-sans)",
    weight: 800
  }, {
    glyph: "We",
    family: "Website Creation",
    category: "Digital · Interface",
    meta: "Responsive sites ·",
    font: "var(--font-sans)",
    weight: 500
  }, {
    glyph: "Pr",
    family: "Product Design",
    category: "UX · UI · Research",
    meta: "Mobile apps ·",
    font: "var(--font-serif)",
    weight: 600
  }, {
    glyph: "Co",
    family: "Content Creations",
    category: "Animation · Video",
    meta: "1000+ creations",
    font: "var(--font-serif)",
    weight: 700
  }];
  return <section data-section-id="18922" id="work-gallery" className="relative bg-background text-foreground py-28 md:py-40">
      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-border" aria-hidden="true" />

      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 md:px-14">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-end transition-all duration-[420ms] ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="md:col-span-8">
            <p className="font-mono text-xs uppercase tracking-[0.14em] text-muted-foreground mb-6">
              {"04 — Portfolio"}
            </p>
            <h2 className="font-default text-foreground" style={{
            fontSize: "clamp(2.5rem, 5.5vw, 5rem)",
            lineHeight: "0.96",
            letterSpacing: "-0.035em",
            fontWeight: 700
          }}>
              Our Creative{" "}
              <span style={{
              fontWeight: 800,
              letterSpacing: "-0.055em"
            }}>
                Portfolio
              </span>
            </h2>
          </div>

          
        </div>

        {}
        <div ref={gridRef} className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {specimens.map((item, i) => <Link key={i} to="/StartYourProjectPage" data-index={i} className={`group block border border-border bg-background transition-all duration-[420ms] ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"} hover:border-[1.5px] hover:border-foreground`} style={{
          transitionDelay: gridVisible ? `${i * 60}ms` : "0ms"
        }}>
              <article className="flex flex-col px-6 pt-10 pb-7 md:px-8 md:pt-10 md:pb-7 h-full">
                {}
                <div className="flex items-end justify-start text-foreground overflow-hidden" style={{
              fontFamily: item.font,
              fontWeight: item.weight,
              fontSize: "clamp(5rem, 8vw, 8rem)",
              lineHeight: "1",
              letterSpacing: "-0.04em",
              minHeight: "clamp(6rem, 9vw, 9rem)"
            }}>
                  <span className="inline-block origin-bottom-left transition-transform duration-[240ms] ease-out group-hover:scale-[1.04]">
                    {item.glyph}
                  </span>
                </div>

                {}
                <h3 className="font-default text-foreground mt-10" style={{
              fontSize: "clamp(1.5rem, 2.2vw, 2.25rem)",
              lineHeight: "1.05",
              letterSpacing: "-0.02em",
              fontWeight: 600
            }}>
                  {item.family}
                </h3>

                {}
                <div className="h-px bg-secondary mt-6" aria-hidden="true" />

                {}
                <div className="mt-5 flex flex-col gap-1.5">
                  <span className="font-mono text-xs uppercase tracking-[0.12em] text-muted-foreground">
                    {item.category}
                  </span>
                  <span className="font-mono text-xs tracking-[0.04em] text-muted-foreground">
                    {item.meta}
                  </span>
                </div>
              </article>
            </Link>)}
        </div>
      </div>
    </section>;
}